import { LicenseValidityContext } from './license-validity-context';
import { ProductCategoryContext } from './product-category-context';

export interface ContextUpdate<T, U = Date> {
  context: T;
  version: string;
  timestamp: U;
}

export type ProductCategoryUpdate<U = Date> = ContextUpdate<ProductCategoryContext, U>;

export type LicenseValidityUpdate<U = Date> = ContextUpdate<LicenseValidityContext<U> | null, U>;
